"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRequestToOrderRequestHeaders = void 0;
const legacy_models_1 = require("@daytrip/legacy-models");
const legacy_utils_1 = require("@daytrip/legacy-utils");
const class_transformer_1 = require("class-transformer");
const request_ip_1 = require("request-ip");
function transformRequestToOrderRequestHeaders(request) {
    if (!request?.headers) {
        return undefined;
    }
    const remoteAddress = (0, request_ip_1.getClientIp)(request);
    const userAgent = request.headers["user-agent"];
    const cid = request.correlationId;
    const client = (0, legacy_utils_1.getDaytripClientFromHeader)(request.headers["x-daytrip-client"], request.headers["x-daytrip-client-platform"]);
    return (0, class_transformer_1.plainToClass)(legacy_models_1.RequestHeader, {
        remoteAddress,
        userAgent,
        client,
        cid,
    });
}
exports.transformRequestToOrderRequestHeaders = transformRequestToOrderRequestHeaders;
//# sourceMappingURL=transformRequestToOrderRequestHeaders.js.map